import {
    type Certificate,
    type CertificateCompanyBranch,
    type CertificateInstance,
    type Company,
    type EnrichedCertificate
} from "../Store/DataSlice";

export function runWebWorker(fn: any, arg: any) {
    return new Worker(
        URL.createObjectURL(new Blob(['(' + fn + ')(' + JSON.stringify(arg) + ')']))
    )
}

let lastCertEnrichWorker: Worker | null = null;

export function runWebWorkerScript(srcUrl: string, arg: any, callback: (ev: MessageEvent<any>) => any) {

    if (lastCertEnrichWorker !== null) {
        lastCertEnrichWorker.terminate();
    }

    lastCertEnrichWorker = new Worker(srcUrl);
    lastCertEnrichWorker.onmessage = e => callback(e);
    lastCertEnrichWorker.postMessage(arg);

}

export function inBrowserCalculateEnrichedCertificates(
    certificates: Certificate[],
    companies: Company[],
    certificateInstances: CertificateInstance[]
): EnrichedCertificate[] {

    if (certificates.length === 0 || certificateInstances.length === 0) {
        return [];
    }

    const companiesByCbe = new Map(
        companies.map(c => [c.vatNumber, c])
    );

    const dateNow = Date.now();

    const calculateCertificateActualStatus: (certificate: Certificate) => any = certificate => {
        if (certificate === undefined) return '';
        if (certificate.status !== 'Valid' && certificate.status !== 'Prolonged') return certificate.status;
        if (certificate.validFrom >= dateNow) {
            return 'NotValidYet';
        }
        if (certificate.validFrom <= dateNow && (certificate.status === 'Prolonged' && certificate.extendedUntil !== undefined ? certificate.extendedUntil : certificate.validUntil) >= dateNow) return certificate.status;
        return 'Expired';
    };

    return certificates.map(certificate => {

        const relatedCompanies = getRelatedCompanies(certificate.companyBranches ?? [], companiesByCbe);

        return {
            ...certificate,
            calculatedStatus: calculateCertificateActualStatus(certificate),
            companyNames: companies.length === 0 ? '...' : relatedCompanies.map(c => c.name).join(', '),
            companyVatNumbers: companies.length === 0 ? '...' : relatedCompanies.map(c => c.vatNumber).join(', '),
            companyPostcodes: companies.length === 0 ? '...' : relatedCompanies.map(c => c.postalCode).join(' '),
            certificateInstanceName: getCertificateInstanceName(certificate.certificateInstanceVatNumber, certificateInstances)
        };
    });

}

function getRelatedCompanies(companyBranches: CertificateCompanyBranch[], companiesByCbe: Map<string, Company>): Company[] {

    if (companyBranches.length === 0 || companiesByCbe.size === 0) {
        return [];
    }

    return companyBranches
        .map(b => b.vatNumber)
        .map(bv => companiesByCbe.get(bv))
        .filter(c => c != null) as Company[];

}

function getCertificateInstanceName(certificateInstanceVatNumber: string, certificateInstances: CertificateInstance[]): string {

    if (certificateInstances.length === 0) {
        return '...';
    }

    const certificateInstance = certificateInstances.find(ci => ci.vatNumber === certificateInstanceVatNumber);

    return certificateInstance?.name ?? '';

}